import { memo, type MouseEvent as ReactMouseEvent, type PointerEvent as ReactPointerEvent } from 'react';

import { XIcon } from '@air/design-icons';
import { tailwindVariants } from '@air/utils-tailwind';

import { type CommentRangeClearButtonSide } from '~/components/v2/components/asset-modal/visualizer/video/VideoCommentRangeSelector/types';

const videoCommentRangeSelectorClearButton = tailwindVariants({
  base: 'group/range-clear pointer-events-none absolute top-1/2 z-30 flex h-4 w-5 -translate-y-1/2 items-center opacity-0 transition-opacity focus-visible:outline-none ads:focus-visible:ring-focus focus-visible:ring-2 focus-visible:ring-blue-9 group-focus-within/range-selector:pointer-events-auto group-focus-within/range-selector:opacity-100 group-hover/range-selector:pointer-events-auto group-hover/range-selector:opacity-100',
  variants: {
    side: {
      left: 'right-full justify-start',
      right: 'left-full justify-end',
    },
  },
});

type VideoCommentRangeSelectorClearButtonProps = {
  onClick: (event: ReactMouseEvent<HTMLButtonElement>) => void;
  onPointerDown: (event: ReactPointerEvent<HTMLButtonElement>) => void;
  side: CommentRangeClearButtonSide;
};

export const VideoCommentRangeSelectorClearButton = memo(
  ({ onClick, onPointerDown, side }: VideoCommentRangeSelectorClearButtonProps) => (
    <button
      aria-label="Clear selected time range"
      className={videoCommentRangeSelectorClearButton({ side })}
      data-testid="VIDEO_COMMENT_RANGE_SELECTOR_CLEAR"
      onClick={onClick}
      onPointerDown={onPointerDown}
      type="button"
    >
      <span className="flex size-4 items-center justify-center rounded-full ads:bg-ads-gray-9 bg-gray-9 ads:text-ads-gray-1 text-gray-1 shadow-sm transition-colors ads:group-hover/range-clear:bg-ads-gray-10 group-hover/range-clear:bg-gray-10">
        <XIcon size="xs" />
      </span>
    </button>
  ),
);

VideoCommentRangeSelectorClearButton.displayName = 'VideoCommentRangeSelectorClearButton';
